Directory = {

	wasLoaded: false,
	isScrolling:false,
	userScrolling:false,
	scrollOnSubpageClick:false,
	openPageAsFixed: true,
	resestSubPageToDefault: false,
	hasArrows: true,
	openPageEl:{},

	loadPages: function () {

		if(typeof Editor != "undefined") return;

		if(!App.hasDirectory) return;

		if(App.debug){
			console.log('--- Directory.loadPages -----------------------------')
		}

		var url = window.location.href.toString().replace(WEB_ROOT+"/", "");
		Directory.scrollToPage(url, 0);
		this.openPageEl = $('.row[url="' + url + '"]').first().attr('state',"open");
		Directory.openPage(this.openPageEl);

		var pages = $('main > .page-placeholder').toArray();

		return Promise.all(
			pages.map(function(page, index) {

				if(App.debug){
					console.log('page', $(page).attr('url'))
				}
				return Directory.loadPagebyURl($(page).attr('url'), 0);
			})
		)

	},

	loadPagebyURl: function (url, index) {
		return new Promise(function(resolve, reject) {
			$.ajax({
				type: "POST",
				url: WEB_ROOT +"/"+ url,
				beforeSend: function(){},
				success: function(result) {
					if ( !result ) 
						return resolve();
					var page = Directory.initPage(index, result, url);
					if(App.debug){
						console.log('url loaded', url);
					}
					resolve();
				},
				error: function(jqXHR, textStatus, errorThrown) {
					console.log("ERROR", jqXHR, textStatus, errorThrown);
					resolve();
				}
			});
		});
	},

	initPage: function (index, result, url) {
		if(App.debug){
			console.log('--- Directory.initPage -----------------------------')
			console.log('arguments:', arguments);
		}

		var page = $('<div>').html(result).find('.page-content .row').first()
			.attr('url', url)
			.addClass('hidden')
		;

		// var placeholder = $(url === '' ? '.page-placeholder[url=]' : '.page-placeholder[url="' + url + '"]');
		var placeholder = $('.page-placeholder[url="' + url + '"]');

		placeholder.replaceWith(page);
		Page.init(page);

		if(App.debug){
			console.log('placeholder', placeholder, 'page:', page);
		}

		return page;
	},

	scrollToPage: function(url, time){

		if(App.debug){
			console.log('--- Directory.scrollToPage -----------------------------')
			console.log(arguments);
		}

		this.scrollOnSubpageClick = window.matchMedia("(max-width: 980px)").matches;
		if(Router.subpage && !this.scrollOnSubpageClick) return;

		var page = $('[url^="' + url + '"]')

		if(url == "" || url == undefined || !page.length){
			this.scroll(0);
		} else{
			var top = page.offset().top + $('.page-content').scrollTop() - parseInt($('.page-content').css('top'));
			Directory.scroll(top, time);
		}

		if(App.debug){
			console.log('page ',  $('[url^="' + url + '"]'), 'top ', top);
		}
	},

	scroll: function(top, time){
		if(App.debug){
			console.log('--- Directory.scroll -----------------------------')
			console.log('arguments', arguments);
		}
		time = time ? time : 700;
		if (!this.wasLoaded){
			time = 0;
		}
		this.isScrolling = true;
		$('.page-content').animate({scrollTop: top }, time, function(){
			Directory.isScrolling = false;
		});
	},

	resetPage: function(){

		var openPages = $('.row[state="open"]')

		if(!openPages.length) return;

		if(App.debug){
			console.log('--- Directory.resetPage -----------------------------')
			console.log('openPages', openPages);
		}
		
		openPages.each(function(index, el) {
			var url = $(this).attr('url').split("/")[0];
			if (url != Router.page){
				$(this).removeAttr('state');
				Page.reset($(this), url);
			}
		});
		
	},

	openPage: function(PAGE){

		this.openPageEl = PAGE;

		if(App.debug){
			console.log('--- Directory.openPageEl -----------------------------');
			console.log('Page.current', Page.current)
		}

		// this.openPageAsFixed = window.matchMedia("(max-width: 980px)").matches

		if(!this.openPageAsFixed) return;
		
		$('<div>', {"class":"page-placeholder-empty", "url":PAGE.attr('url')}).insertBefore(this.openPageEl)
		this.openPageEl.attr('state', 'open');
		
		$('.page-content').css('overflow-y', 'hidden');
	},

	closePage: function(){
		
		if(App.debug){
			console.log('--- Directory.closePage -----------------------------');
			console.log('this.openPageEl', this.openPageEl)
		}

		$('.page-placeholder-empty').remove();
		this.openPageEl.removeAttr('state');

		$('.page-content').css('overflow-y', 'auto');
	},

	addFooter: function(page){
		// $('.page-content .row.footer').appendTo(page);

	},

}
